import {OtsToggleGroup} from "./OtsToggleGroup";

/** Java `DayOfWeek` names, which is how the server serializes days. */
export const OTS_DAYS_OF_WEEK = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"] as const;
export type OtsDayOfWeek = (typeof OTS_DAYS_OF_WEEK)[number];

const WEEKDAYS: OtsDayOfWeek[] = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"];
const WEEKEND: OtsDayOfWeek[] = ["SATURDAY", "SUNDAY"];

const title = (day: string) => day.charAt(0) + day.slice(1).toLowerCase();

export type OtsDayOfWeekPickerProps = {
  value: string[];
  onChange: (value: OtsDayOfWeek[]) => void;
  ariaLabel?: string;
  /** Adds Weekdays / Weekends / Every day shortcuts after the day pills. */
  withPresets?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  size?: "compact" | "default";
  id?: string;
  className?: string;
};

/** Monday-first day picker emitting `DayOfWeek` names in week order. */
export const OtsDayOfWeekPicker = ({
  value,
  onChange,
  ariaLabel = "Days of week",
  withPresets = false,
  disabled,
  invalid,
  size = "default",
  id,
  className,
}: OtsDayOfWeekPickerProps) => {
  const presetClass = [
    "rounded px-1.5 font-semibold text-[var(--ots-primary)] hover:bg-[var(--ots-primary-container)] disabled:opacity-50",
    size === "compact" ? "text-[11px]" : "text-xs",
  ].join(" ");
  return <div className={["flex flex-wrap items-center gap-2", className].filter(Boolean).join(" ")}>
    <OtsToggleGroup<OtsDayOfWeek>
      id={id}
      ariaLabel={ariaLabel}
      options={OTS_DAYS_OF_WEEK.map(day => ({value: day, label: title(day).slice(0, 3), ariaLabel: title(day)}))}
      value={value.filter((day): day is OtsDayOfWeek => (OTS_DAYS_OF_WEEK as readonly string[]).includes(day))}
      onChange={onChange}
      disabled={disabled}
      invalid={invalid}
      size={size}/>
    {withPresets && <div className="flex gap-1">
      <button type="button" className={presetClass} disabled={disabled} onClick={() => onChange(WEEKDAYS)}>Weekdays</button>
      <button type="button" className={presetClass} disabled={disabled} onClick={() => onChange(WEEKEND)}>Weekends</button>
      <button type="button" className={presetClass} disabled={disabled} onClick={() => onChange([...OTS_DAYS_OF_WEEK])}>Every day</button>
    </div>}
  </div>;
};
